var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27085,20.125A11.61882,11.61882,0,0,1,1.981,18.28239a8.356,8.356,0,0,0,.97884.05681,8.23521,8.23521,0,0,0,5.0963-1.756,4.10776,4.10776,0,0,1-3.83328-2.84924,4.09781,4.09781,0,0,0,1.853-.0703,4.10428,4.10428,0,0,1-3.292-4.02173c0-.018,0-.03518.0009-.05229a4.074,4.074,0,0,0,1.85845.51316A4.10468,4.10468,0,0,1,3.373,4.62632a11.6504,11.6504,0,0,0,8.45776,4.286,4.10584,4.10584,0,0,1,6.99265-3.74121,8.224,8.224,0,0,0,2.60544-.99573,4.11661,4.11661,0,0,1-1.80432,2.26924A8.19225,8.19225,0,0,0,21.981,5.79881a8.34763,8.34763,0,0,1-2.047,2.124q.01218.26382.01173.53034A11.59387,11.59387,0,0,1,8.27085,20.125Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.92a487b9.svg";
export { ForwardRef as ReactComponent };